import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { SUBTITLE_SAMPLE_LINK_PROJECT } from '@src/constants/dubbing';
import { useSelector } from 'react-redux';
import FileCopyRoundedIcon from '@mui/icons-material/FileCopyRounded';
import CustomTypography from '@src/new-components/Typography';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { Typography } from '@mui/material';
import SrtIcon from '@src/assets/images/srt-icon.svg';
import SrtFileIcon from '@src/assets/icons/srt-file.svg';
import DirectBoxSendIcon from '@src/assets/icons/directbox-send.svg';
import { StyledDefaultDropzoneContent } from './index.style';
import SampleFileReference from './SampleFileReference';

const DefaultDropzoneContent = ({ isMultipleInputDubbing, fileFormat }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  const { getFeatureValue } = useFeatureFlags();

  const createSrtProjectEnabled = getFeatureValue(
    FEATURE_KEYS.CREATE_SRT_PROJECT,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const isCreateSrtProjectPage = location.pathname.includes('/projects');

  const contentUploadFileSrt = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        textAlign: 'center',
      }}
    >
      <CustomTypography variant="body-16-medium" color="#101323">
        {t('titleUploadFileSrt')}
      </CustomTypography>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          justifyContent: 'center',
        }}
      >
        <CustomTypography variant="body-14-regular" color="#1C1C1EA3">
          {t('referToSampleFileSrt')}
        </CustomTypography>
        <FileCopyRoundedIcon
          sx={{
            fontSize: '20px',
            color: '#1E164E',
          }}
        />
        <a
          href={SUBTITLE_SAMPLE_LINK_PROJECT}
          download
          className="sample-file"
          onClick={(e) => e.stopPropagation()}
          style={{
            color: '#000000CC',
            fontSize: '14px',
          }}
        >
          {t('sampleFileName')}.srt
        </a>
      </div>
    </div>
  );

  const OldDefaultDropzone = () => (
    <StyledDefaultDropzoneContent>
      <img
        style={{
          width: '40px',
          height: '40px',
        }}
        src={
          createSrtProjectEnabled && isCreateSrtProjectPage
            ? SrtIcon
            : SrtFileIcon
        }
        alt="srt-icon"
      />
      {createSrtProjectEnabled && isCreateSrtProjectPage ? (
        contentUploadFileSrt()
      ) : (
        <div className="upload-instruction">
          <Typography align="center" variant="h5" className="upload-file-title">
            {t('dropFileInstruct', { fileFormat })}
          </Typography>
          <SampleFileReference />
        </div>
      )}
    </StyledDefaultDropzoneContent>
  );

  const NewDefaultDropzone = () => (
    <StyledDefaultDropzoneContent>
      <img src={DirectBoxSendIcon} alt="srt-icon" />
      <div className="upload-instruction">
        <Typography
          align="center"
          variant="h5"
          className="upload-file-title text-blue"
        >
          {t('dropFileSuccessInstructSubtitle', { fileFormat })}
        </Typography>
        <SampleFileReference isMultipleInputDubbing />
      </div>
    </StyledDefaultDropzoneContent>
  );

  return isMultipleInputDubbing ? (
    <NewDefaultDropzone />
  ) : (
    <OldDefaultDropzone />
  );
};

export default DefaultDropzoneContent;
